// La société d'id 1 est la racine : un parent_id valant 1 (ou absent) désigne une société de premier niveau.
export const SOCIETE_RACINE_ID = 1;

const estSocieteFille = (societe) => Boolean(societe.parent_id) && societe.parent_id !== SOCIETE_RACINE_ID;

// Parents suivis de leurs filles, puis les filles dont le parent n'est pas dans la liste.
export function trierSocietes(societes) {
  const parents = societes.filter((societe) => !estSocieteFille(societe));
  const filles = societes.filter((societe) => estSocieteFille(societe));
  const idsParents = new Set(parents.map((parent) => parent.id));

  const parentsAvecFilles = parents.flatMap((parent) => [
    parent,
    ...filles.filter((fille) => fille.parent_id === parent.id),
  ]);
  const orphelines = filles.filter((fille) => !idsParents.has(fille.parent_id));

  return [...parentsAvecFilles, ...orphelines];
}
